import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "./Constants";

const CustomLink = ({
  to,
  onClick,
  className,
  children,
  navStop,
  onConfirmation,
}) => {
  return navStop || to === `/${ROUTES.CHANGE_ORG.key}` ? (
    <div onClick={() => onConfirmation(to)} className={className ? className : ""}>
      {children}
    </div>
  ) : (
    <Link to={to} onClick={onClick} className={className ? className : ""}>
      {children}
    </Link>
  );
};
export default CustomLink;
